import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const AudioPlayIcon: FunctionComponent<AudioPlayIconProps> = ({ width = 33, height = 38, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={width} height={height} viewBox='0 0 33 38' fill='none'>
      <Path
        d='M3.02051 0.404487C4.56385 -0.25369 6.4066 -0.0996401 7.77539 0.800971L30.7188 15.8967C31.8412 16.6352 32.5 17.7829 32.5 19.0002C32.4999 20.2175 31.8411 21.3652 30.7188 22.1037L7.77539 37.1994C6.40656 38.1 4.56385 38.2532 3.02051 37.5949C1.4771 36.9365 0.500033 35.5805 0.5 34.0959V3.90449C0.5 2.41984 1.47708 1.06288 3.02051 0.404487Z'
        fill={fillColor || colors.backgroundPrimary}
      />
    </Svg>
  )
}

type AudioPlayIconProps = {
  height?: string | number
  width?: string | number
  fillColor?: string
}
